<div class="payment-results" role="status" aria-live="polite" aria-busy="true">
  <svg class="payment-results__spinner" viewBox="0 0 50 50" aria-hidden="true" focusable="false">
    <circle class="payment-results__spinner-track" cx="25" cy="25" r="20" fill="none" stroke-width="4" />
    <circle class="payment-results__spinner-arc" cx="25" cy="25" r="20" fill="none" stroke-width="4" stroke-linecap="round" />
  </svg>

  <p class="payment-results__title">
    {{ titleKey | translate: { fgbdefault: titleDefault } }}
  </p>
  <p class="payment-results__description">
    {{ descriptionKey | translate: { fgbdefault: descriptionDefault } }}
  </p>
</div>
